mutation BUY_PRODUCT ($id:UUID!, $quantity: Int = 1) {
  buyProduct(id: $id, quantity: $quantity) {
		success
    clientSecret
    customerSessionClientSecret
    orderId
    returnUrl
    total
    message
  }
}
